module.exports = {
    openPicker: async () => Promise.reject(new Error('Image picker not supported on web')),
    openCamera: async () => Promise.reject(new Error('Image picker not supported on web')),
    clean: async () => Promise.resolve(),
};
